export const isDebugActive = () => {
  return !!(window as any).DEBUG;
};

export const activateDebug = () => {
  return ((window as any).DEBUG = true);
};

export const deactivateDebug = () => {
  return ((window as any).DEBUG = false);
};

export const debugGroupStart = (name: string) => {
  return console && console.group && console.group(name);
};

export const outputDebugMessage = (...props) => {
  return console && console.debug && console.debug(...props);
};

export const debugGroupEnd = () => {
  return console && console.groupEnd && console.groupEnd();
};

export const cleanDebugValue = value => {
  if (
    value !== null &&
    typeof value === "object" &&
    value.constructor.name.indexOf("Event") >= 0
  ) {
    return value.constructor.name;
  }

  return value;
};
